import { Button, Card, Col, Form, Input, Row } from 'antd'
import { FormType, useExternalSourceProposal } from './external-source-proposal.hook'
import { useIntl } from 'react-intl'
import { AttachFilesButton } from '../../proposal-files'
import { orderFilesAtom } from '../../proposal-files/order-files.atom'
import { useAtom } from '@reatom/react'
import { useEffect } from 'react'

export function ExternalSourceProposal() {
  const { form, isLoading, isSubmitDisabled, onFinish } = useExternalSourceProposal()
  const intl = useIntl()
  const [{ attachedFilesMap }] = useAtom(orderFilesAtom)

  function getAttachedFiles() {
    return Array.from(attachedFilesMap, ([name, file]) => (file.s3Url || '')).join(',')
  }

  useEffect(() => {
    const formData = form.getFieldsValue()
    formData.proposalFiles = getAttachedFiles()
    form.setFieldsValue(formData)
  }, [attachedFilesMap])

  return (
    <Card bordered>
      <Form<FormType>
        form={form}
        onFinish={onFinish}
        layout='vertical'
      >
        <Row>
          <Col
            span={24}
          >
            <Form.Item
              label={intl.messages['externalSourceProposal.proposalName.label'] as string}
              name='proposalName'
              initialValue=''
            >
              <Input.TextArea
                rows={1}
                placeholder={intl.messages['externalSourceProposal.proposalName.placeholder'] as string}
              />
            </Form.Item>
            <Form.Item
              label={intl.messages['externalSourceProposal.proposalMessage.label'] as string}
              name='proposalMessage'
              rules={[{
                required: true,
                message: intl.messages['externalSourceProposal.proposalMessage.required'] as string,
              }]}
              required
            >
              <Input.TextArea
                rows={3}
                placeholder={intl.messages['externalSourceProposal.proposalMessage.placeholder'] as string}
                required
              />
            </Form.Item>
            <Form.Item name='proposalFiles' hidden shouldUpdate>
              <Input/>
            </Form.Item>
            <Form.Item>
              <AttachFilesButton/>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col
            span={24}
          >
            <Button
              type='primary'
              htmlType='submit'
              disabled={isSubmitDisabled}
              loading={isLoading}
            >
              {intl.messages['externalSourceProposal.proposalMessage.submit'] as string}
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}
